import { Component } from 'react';
import { debounce } from 'underscore';

// @ts-expect-error no types yet
import configureSimpleMenu from 'simple-menus-lib/components/configureSimpleMenu';
// @ts-expect-error no types yet
import Menu from 'simple-menus-lib/components/menu/Menu';
import { userInfoSync } from 'hub-http/userInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_PERIOD = 250;
class SimpleMenuField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.debouncedOnChange = debounce(this.onChange, DEBOUNCE_PERIOD);
    this.SimpleMenusProvider = configureSimpleMenu({
      httpClient: props.httpClient
    });
  }
  onChange(value) {
    const {
      readOnly,
      onFieldChange
    } = this.props;
    if (readOnly || !onFieldChange) return;
    onFieldChange(value);
  }
  render() {
    const {
      readOnly,
      value = []
    } = this.props;
    const {
      SimpleMenusProvider
    } = this;
    return /*#__PURE__*/_jsx(SimpleMenusProvider, {
      auth: userInfoSync(),
      children: /*#__PURE__*/_jsx(Menu, {
        menuData: value,
        onTreeChange: this.debouncedOnChange,
        readOnly: readOnly
      })
    });
  }
}
export default SimpleMenuField;